import { Skeleton } from "@mui/material";
import { BlockCard, SegmentedPillsSkeleton } from "../primitives";
import styles from "./style.module.scss";
import { FunnelView } from "./types";

interface ActivationFunnelBlockSkeletonProps {
  /** Matches the placeholder to whichever view will render. */
  view?: FunnelView;
  count?: number;
  className?: string;
}

function ActivationFunnelBlockSkeleton({
  view = "bars",
  count = 4,
  className,
}: ActivationFunnelBlockSkeletonProps) {
  const rows = Array.from({ length: count });

  return (
    <BlockCard
      title={<Skeleton variant="text" width={150} height={26} />}
      className={className}
      actions={
        <SegmentedPillsSkeleton count={3} width={28} shape="square" />
      }
    >
      {view === "bars" && (
        <div className={styles.bars}>
          {rows.map((_, index) => (
            <div key={index} className={styles.barRow}>
              <div className={styles.barHead}>
                <div className={styles.barLabel}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width={150} height={18} />
                </div>
                <div className={styles.barFigures}>
                  <Skeleton variant="text" width={48} height={20} />
                  <Skeleton
                    variant="rounded"
                    width={52}
                    height={18}
                    sx={{ borderRadius: "10px" }}
                  />
                </div>
              </div>
              <div className={styles.barTrack}>
                <Skeleton
                  variant="rounded"
                  height={10}
                  sx={{ flex: 1, borderRadius: "5px" }}
                />
                <Skeleton variant="text" width={74} height={14} />
              </div>
            </div>
          ))}
        </div>
      )}

      {view === "rings" && (
        <div className={styles.rings}>
          {rows.map((_, index) => (
            <div key={index} className={styles.ringCard}>
              <Skeleton
                variant="circular"
                width={56}
                height={56}
                sx={{ flexShrink: 0 }}
              />
              <div className={styles.ringBody}>
                <Skeleton variant="text" width="80%" height={14} />
                <Skeleton variant="text" width={56} height={22} />
                <Skeleton
                  variant="rounded"
                  width={46}
                  height={16}
                  sx={{ borderRadius: "10px" }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {view === "cols" && (
        <div className={styles.cols}>
          <div className={styles.colChart}>
            {rows.map((_, index) => (
              <div key={index} className={styles.col}>
                <Skeleton variant="text" width={44} height={18} />
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={`${90 - index * 18}%`}
                  sx={{ borderRadius: "8px 8px 4px 4px" }}
                />
              </div>
            ))}
          </div>
          <div className={styles.colLabels}>
            {rows.map((_, index) => (
              <div key={index} className={styles.colLabel}>
                <Skeleton variant="text" width="90%" height={16} />
                <Skeleton variant="text" width="55%" height={14} />
              </div>
            ))}
          </div>
        </div>
      )}
    </BlockCard>
  );
}

export default ActivationFunnelBlockSkeleton;
